import { twcn } from '@web/ui/core/utils';

export type FrameLayout = 'phone' | 'desktop';

/**
 * The traveler app (web-chat) framed at a phone viewport or at a desktop one.
 * Switching only resizes this box: the iframe element (its document, its token)
 * stays the same, and the web-chat follows the new width by itself.
 */
export function AppFrame({
  src,
  title,
  frameRef,
  layout,
}: Readonly<{
  src: string;
  title: string;
  frameRef: React.Ref<HTMLIFrameElement>;
  layout: FrameLayout;
}>): React.JSX.Element {
  return (
    <div
      className={twcn(
        'shrink-0 overflow-hidden rounded-lg border border-border bg-background shadow-overlay',
        // `mx-auto`, not a centered parent: wider than the page, the frame overflows to the
        // right only and stays reachable by scrolling.
        layout === 'phone'
          ? 'mx-auto h-phone-h w-phone-w'
          : 'mx-auto h-full w-full min-w-desktop-frame',
      )}
    >
      {/* eslint-disable-next-line react/iframe-missing-sandbox -- the embedded web-chat runs scripts on its own origin (token handshake, localStorage); the rule allows no sandbox value with both. */}
      <iframe ref={frameRef} src={src} title={title} className="block h-full w-full border-0" />
    </div>
  );
}
